module.exports = __webpack_public_path__ + "img/heart-filled.d22dbf18.svg";